export const BINDING_HEADER = 'x-bazak-guest-auth-binding';

export const SIGN_IN_LINK_TTL_SECONDS = 15 * 60;

export function browserAuthPath({
  tenant,
  action,
}: {
  tenant: string;
  action: 'signin' | 'complete' | 'token' | 'oauth/callback' | 'verify';
}): string {
  return `/api/auth/${encodeURIComponent(tenant)}/${action}`;
}
